const autoNgTemplateLoaderTemplate1 = require('./wizard-view.html');

import angular from 'angular';
import controller from './wizard-view.controller.js';

angular.module('shbdeployer.app').component('wizardView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
});
